import { useToast } from "@vintecc/components";
import { useCommonTranslation } from "@/services/culture/common.translations";

interface UseCopyToClipboard {
  copyToClipboard: (text: string) => void;
}

/**
 * Custom React hook that provides a function to copy text to the clipboard.
 *
 * When the `copyToClipboard` function is called with a string, it copies the text to the user's clipboard
 * and displays a success toast notification.
 */
export const useCopyToClipboard = (): UseCopyToClipboard => {
  const { openToast } = useToast();
  const { t } = useCommonTranslation();

  const copyToClipboard = (text: string, toastMsg?: string) => {
    navigator.clipboard.writeText(text);
    openToast({ message: toastMsg || t("common.copiedToClipboard"), intent: "success" });
  };

  return { copyToClipboard };
};
